import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-date-time-picker',
  templateUrl: './formly-date-time-picker.component.html',
  styleUrls: [],
})
export class FormlyDateTimePickerComponent extends FieldType {}
